exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quillWrapper{border:1px solid #ccc !important;border-radius:0.25rem !important}.ql-toolbar.ql-snow{border:none !important;border-bottom:1px solid #ccc !important}.ql-container.ql-snow{border:none !important}.ql-editor{min-height:120px !important;font-size:1rem !important}\n", ""]);

// exports
